<template>
  <van-pull-refresh
    v-model="refreshing"
    @refresh="onRefresh"
  >
    <!-- <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    > -->
    <van-list>
      <div class="storeBox">
        
        <div
          class="store-item"
          v-for="(item,index) in commodityList"
          :key="index"
        >
          <div class="img-box">
            <img
              :src="item.activityBuyImg"
              alt=""
            >
          </div>
          <div class="store-text">
            <div class="store-title">
              {{item.activityBuyTitle}}
            </div>
            <div class="btn-box">
              <div><span class="money">￥</span><span class="price">{{item.activityBuyPrice}}</span></div>
              <div
                class="my-btn"
                @click="handleClickBug(item.activityBuyLink)">
                立即购买
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
</template>

<script> 
import { Toast } from 'vant';
import axios from "@/utils/NewLive";
export default {
  data () {
    return {
      commodityList:[], // 商品列表
      refreshing: false,
      loading: false,
      finished: false,
      count: 0
    }
  },
  mounted () {
    this.activityId=this.$route.query.id
    this.getCommodity(this.activityId)
  },
  methods: {
    handleClickBug (item) {
      this.$emit('buyNow', item)
      window.open(item,'_balck')
    },
    onLoad () {
      // this.count++
      // this.loading = true
      // // 获取列表数据
      // // this.getStoreList()
      // // 定时器可做加载动画效果
      // setTimeout(() => {
      //   // 
      //   for (let i = 0; i < 10; i++) {
      //     this.list.push({ title: '华为手机支', img: 'https://p6-juejin.byteimg.com/tos-cn-i-k3u1fbpfcp/56cb82e2b2a541569d554f1a1983e994~tplv-k3u1fbpfcp-zoom-mark-crop-v2:460:460:0:0.awebp?', price: i });
      //   }
      //   Toast('加载成功');
      //   this.loading = false
      // }, 1000);
      // // 用count 和 接口返回的页码数据计算是否为最后一页  满足条件后完成finished = true
      // if (this.count == 20) {
      //   this.finished = true
      // }
    },
    // 时间格式转换
    getTime (timestamp) {
        let time = new Date(timestamp)
        let year = time.getFullYear()
        const month = (time.getMonth() + 1).toString().padStart(2, '0')
        const date = (time.getDate()).toString().padStart(2, '0')
        const hours = (time.getHours()).toString().padStart(2, '0')
        const minute = (time.getMinutes()).toString().padStart(2, '0')
        const second = (time.getSeconds()).toString().padStart(2, '0')
        return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second

    },
    // 查询已添加商品列表
    getCommodity (activityId) {
      axios.get(this.$api.activitybuy+'?activityId='+activityId).then(res=>{
              if(res.status===200){
                this.commodityList = res.data.data
              }
            }).catch(() => {});
    },
    onRefresh () {
      this.refreshing = true
      setTimeout(() => {
        Toast('刷新成功');
        this.refreshing = false;
      }, 1000);
    }
  },
}
</script>

<style scoped>
.storeBox {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  margin-top: 10px;
}

.storeBox .store-item {
  width: 100%;
  height: 100px;
  display: flex;
}
.storeBox .store-item .img-box {
  width: 100px;
  height: 100px;
  line-height: 100px;
  background: #f7f7f7;
  text-align: center;
  margin-right: 12px;
  display: flex;
  align-items: center;
}
.storeBox .store-item .img-box img {
  width: 100%;
  height: 100%;
}
.storeBox .store-item .store-text {
  width: 65%;
  font-size: 14px;
}
.storeBox .store-item .store-text .store-title {
  height: 45px;
  font-size: 14px;
  color: #333333;
  line-height: 22px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-bottom: 12px;
}
.money {
  font-size: 14px;
  color: #be1928;
  font-weight: 700;
}
.price {
  font-size: 18px;
  font-weight: 700;
  color: #be1928;
}
.btn-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.my-btn {
  height: 30px;
  font-size: 14px;
  color: #fff;
  line-height: 30px;
  text-align: center;
  border-radius: 15px;
  background: #be1928;
  padding: 0 12px;
}
</style>